<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>회원 공간</p></li>
            <li><p>회원 게시판</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>회원 게시판</span>
          </h1>
        </div>
        <div class="page_con" v-if="!$Util.isEmpty(item)">
          <div class="table detail">
            <div class="row head">
              <div class="cell">
                <p class="left">
                  <span
                    class="lock"
                    :class="{ on: item.board.isSecret === 2 }"
                  ></span>
                  <span class="board_ttl">{{ item.board.boardTitle }}</span>
                </p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{ item.user.userId }}
                </p>
                <p class="date">
                  {{ $moment(item.board.regDate).format('YYYY.MM.DD') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="cell detail_con">
                <div class="editor">
                  <div v-html="item.board.contents"></div>
                  <!--div 꼭 넣어주세요!-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="() => $router.go(-1)">목록으로</button>
        </div>
        <div class="page_con mt30">
          <div class="comment_write">
            <div class="inner">
              <div class="textarea_wrap">
                <textarea
                  placeholder="내용을 입력해 주세요"
                  v-model="form.reviewContent"
                ></textarea>
                <button class="btn" @click="fnSave">댓글 달기</button>
              </div>
            </div>
          </div>
          <div class="table comment">
            <div class="row" v-for="item in items" :key="item.review.reviewNo">
              <div class="cell fix180">
                <p>{{ item.review.adminNo > 0 ? '한국외식산업협회' : item.user.userId }}</p>
              </div>
              <div class="cell">
                <p class="left">{{ item.review.reviewContent }}</p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{
                    $moment(item.review.regDate).format('YYYY.MM.DD HH:mm:ss')
                  }}
                </p>
              </div>
            </div>
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchReviewData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'space-board-view',
  data: function() {
    const query = this.$route.query
    return {
      params: {
        page: 1,
        limit: 10,
        boardNo: Number(query.boardNo)
      },
      boardNo: Number(query.boardNo),
      item: {},
      items: [],
      pageInfo: {},
      form: {
        boardNo: Number(query.boardNo),
        reviewContent: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchReviewData()
  },
  methods: {
    fetchData: async function() {
      const res = await this.$SpaceSvc.getMapBoard({
        boardNo: this.boardNo
      })
      if (res.code === 1) {
        this.item = res.entity
      } else if (res.code === -3000) {
        alert(res.message)
        this.$router.go(-1)
      } else {
        alert(res.message)
      }
    },
    fetchReviewData: async function(page = 1) {
      this.params.page = page
      const res = await this.$SpaceSvc.getListBoxReview(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      } else {
        alert(res.message)
      }
    },
    fnSave: async function() {
      if (!confirm('댓글을 등록하시겠습니까?')) return
      const res = await this.$SpaceSvc.postIntReview(this.form)
      if (res.code === 1) {
        await this.fetchReviewData()
      } else {
        alert(res.message)
      }
    }
  }
}
</script>

<style scoped></style>
